import { IProfile, IServerProfile, IServerUserInfo, IUserInfo } from 'shared/models/Profile'

import { BaseHttpService } from '../BaseHttpService'
import { QueryTypes } from '../data'
import { ProfileConverter } from './ProfileConverter'
import { IDefaultChangePassword, ISlotsHistoryFilters, IUploadDocumentPayload } from './types/types'

class ProfileApi extends BaseHttpService {
  private converter

  private usersUrl

  private betHistoryUrl


  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/user`
    this.usersUrl = `${baseUrl}/api/users`
    this.betHistoryUrl = `${baseUrl}/api/backoffice/betshistory`
    this.converter = new ProfileConverter()
  }

  async getProfileInfo() {
    return this.sendQuery<IServerProfile, IProfile>({
      url: `${this.baseUrl}/profile`,
      type: QueryTypes.GET,
      converterSuccess: this.converter.convertProfileInfo,
    })
  }

  async getUserInfo() {
    return this.sendQuery<IServerUserInfo, IUserInfo>({
      url: `${this.usersUrl}/user/info/`,
      type: QueryTypes.GET,
      converterSuccess: this.converter.convertUserInfo,
    })
  }

  async updateUserInfo(data: IServerUserInfo) {
    return this.sendQuery<IServerUserInfo, boolean>({
      url: `${this.usersUrl}/user/info/`,
      type: QueryTypes.PATCH,
      data,
    })
  }

  async changePassword(data: IDefaultChangePassword) {
    return this.sendQuery<IServerProfile, IProfile>({
      url: `${this.usersUrl}/user/change-password/`,
      type: QueryTypes.POST,
      data,
    })
  }

  async sendKYCpicture(data: FormData) {
    return this.sendQuery({
      url: `${this.usersUrl}/documents/upload/`,
      type: QueryTypes.POST,
      data,
    })
  }

  async getSlotsHistory(data: ISlotsHistoryFilters) {
    return this.sendQuery({
      url: `${this.betHistoryUrl}/`,
      type: QueryTypes.GET,
      data,
      converterSuccess: this.converter.convertSlotsHistory,
    })
  }

  async uploadDocument(data: IUploadDocumentPayload) {
    return this.sendQuery({
      url: `${this.usersUrl}/documents/upload/`,
      type: QueryTypes.POST,
      data,
      options: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    })
  }
}

export default ProfileApi
